/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon16Regular = forwardRef('FoodDrinkAlcoGlassWineIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.75C2 1.784 2.784 1 3.75 1h8.5c.966 0 1.75.784 1.75 1.75v2c0 3.06-2.29 5.585-5.25 5.954V13.5h2.75a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1 0-1.5h2.75v-2.796A6.001 6.001 0 0 1 2 4.75v-2ZM12.438 5.5a4.501 4.501 0 0 1-8.876 0h8.876ZM12.5 4h-9V2.75a.25.25 0 0 1 .25-.25h8.5a.25.25 0 0 1 .25.25V4Z" })));
});
